/**
 * c-filter: クエリのみ変わる遷移を AJAX で差し替え（スクロール位置を維持）
 * context: works | voice | blog | news（PHP が window.kashiwa_c_filter_ajax で渡す）
 */
document.addEventListener('DOMContentLoaded', () => {
  const cfg =
    typeof kashiwa_c_filter_ajax === 'undefined' ? null : kashiwa_c_filter_ajax;
  if (!cfg || !cfg.ajax_url || !cfg.action || !cfg.nonce || !cfg.context) return;

  const resultsRoot = document.querySelector('.js-kashiwa-archive-results');
  const filterRoot = document.querySelector('[data-kashiwa-archive-filter]');
  if (!resultsRoot || !filterRoot) return;

  const normalizePath = (p) =>
    (p || '/').replace(/\/index\.php$/i, '/').replace(/\/+$/, '/') || '/';

  const syncActive = (clickedLi) => {
    if (!clickedLi) return;
    filterRoot.querySelectorAll('.c-filter__item').forEach((li) => {
      li.classList.toggle('is-active', li === clickedLi);
    });
  };

  const getCategoryFromSearch = (params) => {
    let c = params.get('category');
    if (!c || c === 'all') c = null;
    return c;
  };

  /** @returns {'all'|'notice'|'events'} */
  const normalizeNewsTabParam = (params) => {
    const t = params.get('type');
    if (!t || t === 'all') return 'all';
    if (t === 'news' || t === 'notice') return 'notice';
    if (t === 'events') return 'events';
    return 'all';
  };

  const getNewsFilterFromSearch = (params) => normalizeNewsTabParam(params);

  const syncActiveFromUrl = () => {
    const cur = new URL(window.location.href);
    const items = [...filterRoot.querySelectorAll('.c-filter__item')];
    let match = items[0];

    if (cfg.context === 'news') {
      const filter = getNewsFilterFromSearch(cur.searchParams);
      for (const li of items) {
        const aEl = li.querySelector('a[href]');
        if (!aEl) continue;
        let u;
        try {
          u = new URL(aEl.getAttribute('href'), window.location.origin);
        } catch {
          continue;
        }
        const lf = getNewsFilterFromSearch(u.searchParams);
        if (filter === 'all' && lf === 'all') {
          match = li;
          break;
        }
        if (filter !== 'all' && lf === filter) {
          match = li;
          break;
        }
      }
    } else {
      const category = getCategoryFromSearch(cur.searchParams);
      for (const li of items) {
        const aEl = li.querySelector('a[href]');
        if (!aEl) continue;
        let u;
        try {
          u = new URL(aEl.getAttribute('href'), window.location.origin);
        } catch {
          continue;
        }
        const lc = u.searchParams.get('category');
        if (category) {
          if (lc === category) {
            match = li;
            break;
          }
        } else if (
          !u.searchParams.has('category') ||
          u.searchParams.get('category') === '' ||
          u.searchParams.get('category') === 'all'
        ) {
          match = li;
          break;
        }
      }
    }

    items.forEach((li) => li.classList.toggle('is-active', li === match));
  };

  /** @param {{ push?: boolean }} opts */
  const fetchAndReplace = (hrefLike, clickedLi, opts = { push: true }) => {
    const push = opts.push !== false;

    const target =
      hrefLike instanceof URL ? hrefLike : new URL(hrefLike, window.location.href);

    if (target.origin !== window.location.origin) {
      window.location.assign(target.href);
      return Promise.resolve();
    }

    if (normalizePath(target.pathname) !== normalizePath(location.pathname)) {
      window.location.assign(target.href);
      return Promise.resolve();
    }

    let paged = parseInt(target.searchParams.get('paged') || '1', 10);
    if (Number.isNaN(paged) || paged < 1) paged = 1;

    if (clickedLi) syncActive(clickedLi);

    resultsRoot.setAttribute('aria-busy', 'true');

    const fd = new FormData();
    fd.append('action', cfg.action);
    fd.append('security', cfg.nonce);
    fd.append('context', cfg.context);
    fd.append('paged', String(paged));

    if (cfg.context === 'news') {
      const nf = getNewsFilterFromSearch(target.searchParams);
      fd.append('news_filter', nf);
      if (cfg.news_page_id != null && cfg.news_page_id !== '') {
        fd.append('news_page_id', String(cfg.news_page_id));
      }
    } else {
      let category = target.searchParams.get('category');
      if (!category || category === 'all') category = 'all';
      fd.append('category', category === 'all' ? '' : category);

      if (cfg.context === 'blog') {
        const ppp = target.searchParams.get('ppp');
        if (ppp) fd.append('ppp', String(ppp));
      }
    }

    return fetch(cfg.ajax_url, {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
    })
      .then((res) => {
        if (!res.ok) throw new Error(String(res.status));
        return res.json();
      })
      .then((data) => {
        if (!data || !data.success || !data.data || typeof data.data.html !== 'string') {
          throw new Error('Invalid JSON');
        }
        resultsRoot.innerHTML = data.data.html;
        if (push) {
          window.history.pushState({}, '', `${target.pathname}${target.search}${target.hash}`);
        }
      })
      .catch(() => {
        window.location.assign(target.href);
      })
      .finally(() => {
        resultsRoot.setAttribute('aria-busy', 'false');
      });
  };

  filterRoot.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a || !filterRoot.contains(a)) return;

    try {
      const url = new URL(a.getAttribute('href'), window.location.href);
      if (url.origin !== window.location.origin) return;
      if (normalizePath(url.pathname) !== normalizePath(location.pathname)) return;

      e.preventDefault();

      fetchAndReplace(url, a.closest('.c-filter__item'), { push: true });
    } catch {
      /* 通常遷移 */
    }
  });

  window.addEventListener('popstate', () => {
    syncActiveFromUrl();
    fetchAndReplace(window.location.href, null, { push: false });
  });
});
